<template>
  <el-card class="no-padding-header">
    <div slot="header" class="clearfix frete-rapido">
      <img src="/img/integration/logo-frete-rapido.png" class="integration-image" />
    </div>    
    <el-form :model="ruleForm">
      <el-form-item prop="active">
        <el-checkbox v-model="ruleForm.active">Habilitar Webhook SRO</el-checkbox>
      </el-form-item>
      <el-form-item label="CNPJ" prop="cnpj">
        <el-col :xs="24" >
          <el-input :disabled="!ruleForm.active" v-model="ruleForm.federalid"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Token" prop="token">
        <el-col :xs="24" >
          <el-input :disabled="!ruleForm.active" v-model="ruleForm.token"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  name: "FreteRapidoComponent",
  data() {
    return {
      ruleForm: {
        token: '',
        federalid: '',
        active: false,
      }
    }
  },
  methods: {
    get() {
      return this.ruleForm;
    },
    setup(data) {
      const vm = this;
      console.log('setup', data.webhooks)
      if (data.webhooks) {
        const webhooks = JSON.parse(data.webhooks);
        if (webhooks.freterapido) {
          console.log('do', webhooks.freterapido)
          vm.ruleForm.token = webhooks.freterapido.token;
          vm.ruleForm.federalid = webhooks.freterapido.federalid;
          vm.ruleForm.active = webhooks.freterapido.active;
          console.log('done', vm.ruleForm)
        }
      }
    }
  }
};
</script>
<style> 
  .frete-rapido {
    width: 100%;
    background-color: #DB251F;
    text-align: center;
  }
  .no-padding-header .el-card__header {
    padding: 0;
  }  
</style>